
(() => {
  'use strict';

  const config = window.LunnaxorShieldConfig || {};
  const html = document.documentElement;
  html.classList.add('lnx-shield-enabled');

  const isCollection = location.pathname.startsWith('/collections/');
  const isProtectedArea = (target) =>
    target instanceof Element &&
    Boolean(target.closest('main img, .product-media, .product-gallery, [data-lnx-protect]'));

  const showNotice = (message) => {
    let node = document.querySelector('.lnx-shield-notice');
    if (!node) {
      node = document.createElement('div');
      node.className = 'lnx-shield-notice';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(showNotice.timer);
    showNotice.timer = setTimeout(() => node.classList.remove('is-visible'), 1800);
  };

  // Remove public sorting parameters before the sorted page remains visible.
  if (config.lockCollectionSorting !== false && isCollection) {
    const url = new URL(location.href);
    if (url.searchParams.has('sort_by')) {
      url.searchParams.delete('sort_by');
      location.replace(url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : '') + url.hash);
      return;
    }
  }

  // Casual hiding of /collections/all. This is a browser redirect, not server access control.
  if (config.redirectCollectionsAll === true && location.pathname === '/collections/all') {
    location.replace(config.collectionsAllRedirect || '/collections');
    return;
  }

  // Prevent drag-save on storefront imagery.
  if (config.protectImages !== false) {
    document.addEventListener('dragstart', (event) => {
      if (isProtectedArea(event.target)) event.preventDefault();
    }, true);

    document.addEventListener('contextmenu', (event) => {
      if (!isProtectedArea(event.target)) return;
      event.preventDefault();
      showNotice(config.imageNotice || 'This image is protected by Lunnaxor.');
    }, true);
  }

  // Small friction against "view source" and "save page"; avoids disabling normal copy/paste.
  if (config.keyboardDeterrence === true) {
    document.addEventListener('keydown', (event) => {
      const key = String(event.key || '').toLowerCase();
      const ctrlOrMeta = event.ctrlKey || event.metaKey;
      const blocked = ctrlOrMeta && (key === 'u' || key === 's');
      if (!blocked) return;
      event.preventDefault();
      showNotice(config.keyboardNotice || 'Store content is protected.');
    }, true);
  }

  // Add brand attribution when a long text selection is copied from product content.
  if (config.copyAttribution === true) {
    document.addEventListener('copy', (event) => {
      const selection = String(window.getSelection() || '').trim();
      if (selection.length < 180) return;
      const focus = document.activeElement;
      if (focus && /^(INPUT|TEXTAREA)$/.test(focus.tagName)) return;

      const attribution = `\n\nSource: ${document.title} — ${location.origin}`;
      event.clipboardData?.setData('text/plain', selection + attribution);
      event.preventDefault();
    });
  }
})();
